<template>
  <div class="has-text-centered">
    <h1 class="text-shadow">
      Shop AHL Coming soon!
    </h1>
  </div>
</template>

<script>
  export default {
    name: 'ShopIndex',
    data () {
      return {}
    },
    methods: {}
  }
</script>